import { Helmet } from "react-helmet-async";

export const SITE = "https://ymagazine.com";
const DEFAULT_IMAGE = `${SITE}/img/hero-street.jpg`;

const abs = (u) => (!u ? DEFAULT_IMAGE : u.startsWith("http") ? u : `${SITE}${u.startsWith("/") ? "" : "/"}${u}`);
export const clip = (s = "", n = 158) => {
  const t = s.replace(/\s+/g, " ").trim();
  return t.length <= n ? t : `${t.slice(0, t.lastIndexOf(" ", n - 1))}…`;
};

export const Seo = ({ title, description, path, image, type = "website", noindex = false, jsonLd }) => {
  const url = `${SITE}${path ?? ""}`;
  const img = abs(image);
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      {path !== undefined && <link rel="canonical" href={url} />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {path !== undefined && <meta property="og:url" content={url} />}
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
